import React, { useState, useEffect } from 'react';

import api from '../services/api';

import FormInput from '../FormInput'
import FormSelect from '../FormSelect'
import PageSubtitle from '../PageSubtitle'
import ButtonHover from '../ButtonHover'
 

let buttonStyleTrue = {
  width: '24px',
  height: '24px',
  background: 'green',
  borderRadius: '5px',
  border: 'none',
  padding: '0',
  margin: '2px 10px 0 0',
}

let buttonStyleFalse = {
  width: '24px',
  height: '24px',
  background: 'white',
  borderRadius: '5px',
  border: 'none',
  padding: '0',
  margin: '2px 10px 0 0',
}


export default function ProjectEdit (props){
  
  const[projectId, setProjectId] = useState("")
  const[title, setTitle] = useState("")
  const[institution, setInstitution] = useState("")
  const[specialty, setSpecialty] = useState("")
  const[stateName, setStateName] = useState("")
  const[completion, setCompletion] = useState("")
  const[publicationType, setPublicationType] = useState("")
  const[studyType, setStudyType] = useState("")
  const[skills, setSkills] = useState("")
  const[formalName, setFormalName] = useState("")
  const[summary, setSummary] = useState("")

    const updateProject = async(e) => {
      e.preventDefault();
      try {

        await api.put('/project', {
          projectId,
          title, 
          institution, 
          specialty, 
          stateName, 
          completion, 
          publicationType, 
          studyType, 
          formalName, 
          skills, 
          summary
        });
        // console.log('yup')
        window.location = "/home";

      } catch (err) {
        console.error(err.message)
      }
    }


    useEffect(() => {
      props.projectUserData.map(p => {
        if(p.project_id === props.projectModal){
          setProjectId(p.project_id)
          setTitle(p.title)
          setInstitution(p.institution)
          setSpecialty(p.specialty)
          setStateName(p.state_name)
          setCompletion(p.completion)
          setPublicationType(p.publication_type)
          setStudyType(p.study_type)
          setFormalName(p.formal_name)
          setSkills(p.skills)
          setSummary(p.summary)
        }
      })
    }, [])


    return(
      <div>
        <div style={{display: 'flex'}}>
          <div style={{
              width: '7vw',
              height: '84vh'
            }}>
          </div>
          <div style={{width: '86vw'}}>
            <div style={{height: '50px'}}></div>
            <PageSubtitle
              pageSubtitle = 'Now the good stuff... tell us about your project.'
              />
            <form onSubmit={updateProject}>
              <FormInput
                autoFocus
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="What is the title of your project"
                />
              <FormSelect
                hook={specialty}
                setHook={setSpecialty}
                selectOptions={specialtyOptions}
                />
              <FormInput
                value={institution}
                onChange={e => setInstitution(e.target.value)}
                name='institution'
                placeholder="What is your residency program's name?"
                />
              <FormInput
                value={stateName}
                onChange={e => setStateName(e.target.value)}
                name='stateName'
                placeholder='What state are you in?'
                />
              <FormInput
                value={completion}
                onChange={e => setCompletion(e.target.value)}
                name='completion'
                placeholder='When will your study be finished (year)'
                />
              <FormInput
                value={publicationType}
                onChange={e => setPublicationType(e.target.value)}
                name='publicationType'
                placeholder='How will your research be presented (journal, poster, meeting)'
                />
              <FormInput
                value={studyType}
                onChange={e => setStudyType(e.target.value)}
                name='studyType'
                placeholder="What type of study is this (e.g., 'Cohort')"
                />
              <FormInput
                value={summary}
                onChange={e => setSummary(e.target.value)}
                name='summary'
                placeholder="Please give a summary of your project"
                />
              <FormInput
                value={formalName}
                onChange={e => setFormalName(e.target.value)}
                name='formalName'
                placeholder='Your name and credentials?'
                />
              <FormInput
                value={skills}
                onChange={e => setSkills(e.target.value)}
                name='skills'
                placeholder='What kind of skills does your project need?'
                />
              <div
                style={{
                  margin: '30px 0 150px 0',
                  display: 'flex',
                  justifyContent: 'center'}}
                  >
                <ButtonHover
                  buttonName = "Submit"
                  pageRef = "/home"
                  />
              </div>
            </form>



            <div style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '10px 0 0 0'
              }}>
              <div style={{
                  width: '620px',
                  display: 'flex',
                }}>
                <button
                  style={props.certification === true
                    ? buttonStyleTrue
                    : buttonStyleFalse
                  }
                  value={props.certification}
                  onClick={props.onButtonClick}
                  name="certification"
                  >
                </button>
                <p style={{
                  width:'600px',
                  margin: '0',
                  fontSize: '16px',
                  fontFamily: 'Montserrat',
                  fontWeight: '600',
                  color: '#FFF',
                  }}>
                  I certify that this project is IRB approved or IRB exempt, that the above information is true, and I recognize that this website is in no way responsible for the content I post or any potential HIPPA violations.
                </p>
              </div>
            </div>
          </div>
          <div style={{
              width: '7vw',
              height: '84vh'
            }}>
          </div>
        </div>
      </div>

    )
  }


  const specialtyOptions = 
  [
    {title: 'Choose your specialty...', value: ''},
    {title: 'Anesthesiology', value: 'Anesthesiology'},
    {title: 'Cardiology', value: 'Cardiology'},
    {title: 'Dermatology', value: 'Dermatology'},
    {title: 'Emergency Medicine', value: 'Emergency Medicine'},
    {title: 'Endocrinology', value: 'Endocrinology'},
    {title: 'Family Medicine', value: 'Family Medicine'},
    {title: 'Gastroenterology', value: 'Gastroenterology'},
    {title: 'General Surgery', value: 'General Surgery'},
    {title: 'Hematology/Oncology', value: 'Hematology/Oncology'},
    {title: 'Infectious Disease', value: 'Infectious Disease'},
    {title: 'Internal Medicine', value: 'Internal Medicine'},
    {title: 'Nephrology', value: 'Nephrology'},
    {title: 'Neurology', value: 'Neurology'},
    {title: 'Neurosurgery', value: 'Neurosurgery'},
    {title: 'Obstetrics/Gynecology', value: 'Obstetrics/Gynecology'},
    {title: 'Orthopedics', value: 'Orthopedics'},
    {title: 'Otolaryngology', value: 'Otolaryngology'},
    {title: 'Pathology', value: 'Pathology'},
    {title: 'Pediatrics', value: 'Pediatrics'},
    {title: 'Plastic Surgery', value: 'Plastic Surgery'},
    {title: 'Psychiatry', value: 'Psychiatry'},
    {title: 'Pulmonology', value: 'Pulmonology'},
    {title: 'Radiology', value: 'Radiology'},
    {title: 'Urology', value: 'Urology'},
    {title: 'Vacular Surgery', value: 'Vacular Surgery'},
    {title: 'Other', value: 'Other'},
  ]




//   <div style={{
//     margin: '30px 0 150px 0',
//     display: 'flex',
//     justifyContent: 'center'}}>
//   <ButtonHover
//     buttonName = "Submit"
//     pageRef = "/"
//     />
// </div>